<template>
    <div class="qr-code-hint">
        <div class="center-center">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 1160 1160" xml:space="preserve"><path class="st0" d="M480 120v40h80v40h40v40h-40v120h40v-80h40v80h40v-80h80v-40h-40v-40h40v-80h-40v40h-40v40h-40V80h-40v40h-80V80H400v80h40v-40z"/><path class="st0" d="M440 160h40v40h-40zM400 200h40v40h-40zM480 200h40v40h-40zM480 360h40v-80h-40v-40h-40v80h40zM440 360v-40h-40v80h40zM240 440v-40h-80v40h40zM480 440h40v-40h-80v40zM720 440v40h40v40h40v-80h-40V320h-40v80h-80v40h40zM800 400h40v40h-40zM920 400h40v40h-40zM1040 400h-40v80h40v-40h40v-40zM160 480v-40h-40v-40H80v80h40v40h40zM840 520h40v-80h-40v40zM400 520h40v-80h-40v-40H280v40h80v40h-40v40h40v40h40z"/><path class="st0" d="M1000 560v-40H880v80h-40v-80h-40v40H640V440h-40v40h-80v80h40v-40h40v80h40v40h-80v80h40v-40h40v40h-40v40h120v160h-40v40h80v80h40v40h280v-40h-80v-40h40v-40h40v-40h-40v-40h40V680h-40v40H920V560h40v40h80v40h40v-80h-80zM720 680v40h-40v-80h40v40zm160 280v80h-40V920h40v40zm0-160v80H760V760h120v40zm0-120H760v-40h120v40zm80 320v40h-40v-80h40v40zm40-240h40v40h-40v-40zm-40 0v80h40v80h-40v-40h-40V760h40zM200 600h40v-40H120v-40H80v80h80v40h40zM360 600h40v40h-40z"/><path class="st0" d="M520 600h40v40h-40zM120 640h40v40h-40zM200 640h40v40h-40zM960 640v40h80v-40h-40zM80 680h40v40H80zM160 680h40v40h-40zM480 760v40h40v-40h40v-40h-40v-40h-40v40z"/><path class="st0" d="M560 800h-40v40h40v40h-80v-80h-40V680h40V520h-40v120h-40v80h-80v-40h40v-40h-40v-40h40v-40h-80v120h-40v80h160v120h40v40h-40v80h40v-40h80v-40h40v40h-40v40h120V880h-40v-40h80v-40h-80v-40h-40zM800 800h40v40h-40zM480 1000h40v40h-40zM400 1040h40v40h-40zM560 1040h40v40h-40zM640 1040h40v40h-40z"/><g><path class="st1" d="M43.6 43.6h70v70h-70z" transform="scale(2.8)"/><path class="st0" d="M113.6 28.6h-85v100h100v-100h-15zm0 85h-70v-70h70v70z" transform="scale(2.8)"/></g><g><path class="st1" d="M43.6 43.6h70v70h-70z" transform="translate(720) scale(2.8)"/><path class="st0" d="M113.6 28.6h-85v100h100v-100h-15zm0 85h-70v-70h70v70z" transform="translate(720) scale(2.8)"/></g><g><path class="st1" d="M43.6 43.6h70v70h-70z" transform="matrix(2.8 0 0 2.8 0 720)"/><path class="st0" d="M113.6 28.6h-85v100h100v-100h-15zm0 85h-70v-70h70v70z" transform="matrix(2.8 0 0 2.8 0 720)"/></g><g><path class="st0" d="M66.7 66.7h100v100h-100z" transform="matrix(1.2 0 0 1.2 80 80)"/></g><g><path class="st0" d="M66.7 66.7h100v100h-100z" transform="matrix(1.2 0 0 1.2 800 80)"/></g><g><path class="st0" d="M66.7 66.7h100v100h-100z" transform="matrix(1.2 0 0 1.2 80 800)"/></g></svg>
            <h2>Please open the app on your mobile, by visiting<br><br>https://oralb.tmc.one<br><br>or scan the QR code
            </h2>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'DesktopHint',
    }
</script>

<style lang="scss">

    .qr-code-hint {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: #fff;
        display: none;
        justify-content: center;
        align-items: center;

        .center-center {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 30%;
            text-align: center;

            svg {
                width: 75%;

                .st0 {
                    fill: $ioBlue;
                }
                .st1 {
                    fill: none;
                }
            }

            h2 {
                color: $oralGray;
                padding: 0 1rem;
                margin-top: 1rem;
                font-size: 1.25rem;
            }
        }


    }

    @media all and (min-width: 768px) {
        #app > *:not(:last-child) {
            display: none;
        }
        .qr-code-hint {
            display: flex;
        }
    }
</style>
